import { Label } from 'components/ui/label';
import { Input } from 'components/ui/input';
import React from 'react';
import { FieldValues, UseFormRegister } from 'react-hook-form';
import { PAYMENT_CONFIG } from 'state/paymentConfig/type';

interface Iprops {
  config: PAYMENT_CONFIG.IProcessorConfiguration;
  register: UseFormRegister<FieldValues>;
  className?: string;
}
const ConfigInput = ({ config, register, className }: Iprops) => {
  const { ref, ...field } = register(config.code, {
    required: config.isRequired,
  });

  return (
    <>
      <div className="mb-3 mr-3">
        <Label htmlFor={config.code} className="text-sm font-medium text-gray-blue-80 mb-1">
          {config.displayName}
        </Label>
        <Input
          ref={ref}
          {...field}
          data-testid={`config-${config.code}`}
          id={`config-${config.code}`}
          className={`w-full max-w-3xl bg-gray-blue-1 ${className || ''}`}
        />
      </div>
    </>
  );
};

export default ConfigInput;
